var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { create } from "zustand";
import { RoomChangedMessage, MediaScreenFacet } from "flavr-common";
import { busService } from "../../modules/bus/BusService";
import { findMediaScreenModelsInRoom } from "@messages/mediaScreen";
export const useScreenShareStore = create((set) => ({
    screenShareSurfaces: [],
    setScreenShareSurfaces: (screenShareSurfaces) => {
        set({ screenShareSurfaces });
    }
}));
let currentRoomUID = 0;
function initScreenShareStore() {
    return __awaiter(this, void 0, void 0, function* () {
        const sendUpdate = () => {
            if (busService.connection("ScreenShareStore").isReady()) {
                busService.connection("ScreenShareStore").subscribeByType(RoomChangedMessage, handleRoomChangedMessage);
                busService.connection("ScreenShareStore").subscribeByFacetType(MediaScreenFacet, updateScreenShareSurfacesFromRoom);
                busService.connection("ScreenShareStore").subscribeByRemoveFacetType(MediaScreenFacet, updateScreenShareSurfacesFromRoom);
            }
            else {
                setTimeout(sendUpdate, 100);
            }
        };
        sendUpdate();
    });
}
function updateScreenShareSurfacesFromRoom() {
    if (currentRoomUID === 0)
        return;
    const models = findMediaScreenModelsInRoom(currentRoomUID);
    useScreenShareStore.getState().setScreenShareSurfaces(models.map((model) => ({
        surfaceModelUid: model.getUID(),
        surfaceModelName: model.getName()
    })));
}
function handleRoomChangedMessage(msg) {
    currentRoomUID = msg.uid;
    updateScreenShareSurfacesFromRoom();
}
initScreenShareStore()
    .then(() => __awaiter(void 0, void 0, void 0, function* () { }))
    .catch((error) => {
    console.error("[ui] Error initializing screen share store:", error);
});
